import { useAuthStore } from "../stores/authStore";

export function DashboardPage() {
  const user = useAuthStore((state) => state.user);

  return (
    <div className="p-6">
      <div className="bg-white rounded-xl border border-gray-200 p-8 text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Welcome, {user?.name}!</h2>
        <p className="text-gray-600">Your dashboard is ready. More features coming soon.</p>
      </div>
    </div>
  );
}
